import { render } from "./IconPreloader.vue?vue&type=template&id=b2905a18&bindings={\"id\":\"props\"}"
import script from "./IconPreloader.vue?vue&type=script&lang=js"
export * from "./IconPreloader.vue?vue&type=script&lang=js"
script.render = render

export default script